export const STYLES = {
  WRAPPER: 'relative w-full h-full flex items-center justify-between gap-[24px] bg-bw00 ml-[100px] pc-md:ml-[256px]',
  PROFILE: 'absolute right-[35px] top-[25px]',
  CHATBOT:
    'absolute right-[10px] bottom-[100px] z-40 w-[46px] h-[46px] rounded-full bg-action03 flex items-center justify-center cursor-pointer shadow-helpMenuButton hover:bg-action04',
  CHILDREN: 'grow h-full overflow-y-auto',
};
